module.exports = __webpack_public_path__ + "img/show.9ceb0fda.jpg";